var _circle, _rect, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F6F7F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    transform: "translate(14 14)",
    fill: "#F6F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8602 36.2218H15V16H35.2218V26.8625",
    stroke: "#A3B0B3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.9941H35.2218V20.4941H15V21.9941Z",
    fill: "#A3B0B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8086 26.4873H23.4258V24.9873H17.8086V26.4873Z",
    fill: "#A3B0B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8086 29.2959H26.9195V27.7959H17.8086V29.2959Z",
    fill: "#A3B0B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7765 36.7773L41 41.0009",
    stroke: "#A3B0B3",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 4.5,
    stroke: "#A3B0B3",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5278 17.6855C17.0621 17.6855 16.6852 18.0625 16.6852 18.5281C16.6852 18.9938 17.0621 19.3707 17.5278 19.3707C17.9934 19.3707 18.3703 18.9938 18.3703 18.5281C18.3703 18.0625 17.9934 17.6855 17.5278 17.6855",
    fill: "#A3B0B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3364 17.6855C19.8707 17.6855 19.4938 18.0625 19.4938 18.5281C19.4938 18.9938 19.8707 19.3707 20.3364 19.3707C20.802 19.3707 21.1789 18.9938 21.1789 18.5281C21.1789 18.0625 20.802 17.6855 20.3364 17.6855",
    fill: "#A3B0B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1449 17.6855C22.6793 17.6855 22.3024 18.0625 22.3024 18.5281C22.3024 18.9938 22.6793 19.3707 23.1449 19.3707C23.6106 19.3707 23.9875 18.9938 23.9875 18.5281C23.9875 18.0625 23.6106 17.6855 23.1449 17.6855",
    fill: "#A3B0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading2.c903a133b70f4221a5fe8248d0e44e80.svg";
export { ForwardRef as ReactComponent };